import type { ISignInSettings } from '@srm/core/auth';
import type { AppDispatch } from '@/store';
import { AuthSlice } from '@/store/reducers/AuthReducer';
import { auth } from './index';

/**
 * Ответ `GET Account/SignInSettings` — в сессию и стор: режим сессии, флаг связки учётных записей, настройки формы.
 * Сессия — до стора: компоненты, которые перерисует стор, уже видят `auth.accounts.enabled()`.
 */
export function applySignInSettings(dispatch: AppDispatch, settings: ISignInSettings): void {
    auth.setMode(settings.authMode || 'body');
    auth.accounts.configure(settings.multiAccount);
    dispatch(AuthSlice.actions.setSignInSettings(settings));
}
